import { Box } from "@mui/material";
import React, { useEffect } from "react";

import AboutTurno from "../../modules/AboutUs/AboutTurno/aboutTurno";
import Career from "../../modules/AboutUs/Career/career";
import Investors from "../../modules/AboutUs/Investors/investors";
import TurnoMission from "../../modules/AboutUs/Mission/mission";
import Team from "../../modules/AboutUs/Team/team";
import TurnoInIndia from "../../modules/AboutUs/TurnoInIndia/turnoInIndia";
import { sendAnalytics } from "../../utils/analyticsCommon";

const AboutUs = () => {
  useEffect(() => {
    sendAnalytics("screen_viewed", { screen_name: "about us screen" }, "en");

    // eslint-disable-next-line
  }, []);

  return (
    <Box>
      <AboutTurno />
      <TurnoMission />
      <TurnoInIndia />
      <Investors />
      <Team />
      <Career />
    </Box>
  );
};
export default AboutUs;
